export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  imageUrl: string;
  chapterCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '初入豪门',
    slug: 'entering-wealth',
    description: '她以为嫁入豪门是幸福的开始，却不知这是一场精心设计的赌局。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20mansion%20room%20with%20warm%20ambient%20lighting%2C%20elegant%20velvet%20furniture%2C%20ornate%20decorative%20details%2C%20atmospheric%20cinematic%20mood%2C%20rich%20burgundy%20and%20gold%20accents%2C%20mysterious%20luxurious%20interior%2C%20no%20people%2C%20dark%20aesthetic&width=600&height=750&seq=cat-entering-wealth&orientation=portrait',
    chapterCount: 38,
  },
  {
    id: 'cat-2',
    name: '荒唐赌约',
    slug: 'absurd-bet',
    description: '一纸荒唐赌约，将她推入万劫不复的深渊，欲望的潘多拉魔盒由此打开。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20luxurious%20study%20room%20with%20antique%20wooden%20desk%2C%20candlelight%20shadows%2C%20old%20contracts%20and%20documents%2C%20mysterious%20atmosphere%2C%20deep%20crimson%20walls%2C%20ornate%20gold%20frames%2C%20cinematic%20noir%20lighting%2C%20wealthy%20mansion%20interior%2C%20no%20people&width=600&height=750&seq=cat-absurd-bet&orientation=portrait',
    chapterCount: 42,
  },
  {
    id: 'cat-3',
    name: '情欲迷局',
    slug: 'desire-maze',
    description: '在情欲的迷宫中，她越陷越深，每一次挣扎都是更深的沦陷。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20bedroom%20with%20soft%20candlelight%2C%20rose%20petals%20scattered%2C%20sheer%20curtains%20blowing%20in%20breeze%2C%20luxurious%20silk%20bedding%2C%20warm%20amber%20tones%2C%20romantic%20yet%20mysterious%20atmosphere%2C%20cinematic%20soft%20focus%2C%20rich%20textures%2C%20no%20people&width=600&height=750&seq=cat-desire-maze&orientation=portrait',
    chapterCount: 35,
  },
  {
    id: 'cat-4',
    name: '真相渐露',
    slug: 'truth-revealed',
    description: '当真相一点点浮出水面，她才发现自己从一开始就是棋盘上的棋子。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Grand%20library%20with%20towering%20bookshelves%2C%20dim%20mysterious%20lighting%2C%20dust%20motes%20in%20sunlight%20beams%2C%20old%20letters%20and%20secrets%2C%20ornate%20wooden%20interior%2C%20dramatic%20shadows%2C%20gothic%20atmosphere%2C%20cinematic%20noir%20style%2C%20no%20people&width=600&height=750&seq=cat-truth-revealed&orientation=portrait',
    chapterCount: 40,
  },
  {
    id: 'cat-5',
    name: '最终抉择',
    slug: 'final-choice',
    description: '站在命运的十字路口，她必须做出最后的抉择——爱情还是自由？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sunlit%20elegant%20mansion%20entrance%20hall%20with%20open%20doors%2C%20golden%20hour%20light%20streaming%20in%2C%20marble%20floors%2C%20grand%20staircase%2C%20hopeful%20yet%20contemplative%20atmosphere%2C%20warm%20golden%20tones%2C%20cinematic%20composition%2C%20luxurious%20interior%2C%20no%20people&width=600&height=750&seq=cat-final-choice&orientation=portrait',
    chapterCount: 31,
  },
];